import React from 'react';
import './style.css';
import tickMarkIcon from '../../../assets/icons/completed.svg';

const DashboardProgressBar = ({ isStoreCreated, isBranchAdded, isCategoriesCreated, isProductAdded, isDeployed}) => {

    const StatusIndicatorCircle = ({ status ,stepCount}) => {

        let style = {};
        let textStyle ={};
        if (status === 'AWAIT') {
            style = { backgroundColor: '#A5D1E6' }; // Example styles for 'await'
        } else if (status === 'PENDING') {
            style = { backgroundColor: '#0094DC'}; // Example styles for 'pending'
            textStyle ={color: '#0094DC'}
        } else {
            style = { backgroundColor: '#219581' }; // Example styles for other statuses
            textStyle ={color: '#219581'}
        }
        return (
            <div>
            <div className="status-indicator-circle" style={style}>
                {status ==="COMPLETED" && <img
                loading="lazy"
                alt="icon"
                srcSet={tickMarkIcon}
                className="shrink-0 rounded-lg aspect-[1.02] w-[45px]"
                style={{ height: '15px' }}
              />}
              {status ==="PENDING" && <div className="status-indication-pending-circle"></div>}
            </div>
            <div className="steps-indicater">
                    <div className="steps-indicater-label">
                        Step {stepCount}
                    </div>
                    
                    {status ==="PENDING" &&  <div className="steps-indicater-status" style={textStyle}>In Progress</div>}
                    {status ==="AWAIT" &&  <div className="steps-indicater-status" style={textStyle}>Pending</div>}
                    {status ==="COMPLETED" &&  <div className="steps-indicater-status" style={textStyle}>Completed</div>}
            </div>
            </div>
        );
    };

    const StatusIndicatorBar = ({ status }) => {

        let StatusIndicatorBarstyle = {};
        if (status === 'AWAIT') {
            StatusIndicatorBarstyle = { backgroundColor: '#A5D1E6' }; // Example styles for 'await'
        } else if (status === 'PENDING') {
            StatusIndicatorBarstyle = { backgroundColor: '#A5D1E6'}; // Example styles for 'pending'
        } else {
            StatusIndicatorBarstyle = { backgroundColor: '#219581' }; // Example styles for other statuses
        }
        return (
            <div className="status-indicator-bar" style={StatusIndicatorBarstyle}>
              {status ==="PENDING" && <div className="status-indication-pending-bar"></div>}
            </div>
        );
    };

    // const StatusInfoIndicatorText = ({ status }) => {

    //     let StatusIndicatorBarstyle = {};
    //     if (status === 'AWAIT') {
    //         StatusIndicatorBarstyle = { backgroundColor: '#A5D1E6' }; // Example styles for 'await'
    //     } else if (status === 'PENDING') {
    //         StatusIndicatorBarstyle = { backgroundColor: '#A5D1E6'}; // Example styles for 'pending'
    //     } else {
    //         StatusIndicatorBarstyle = { backgroundColor: '#219581' }; // Example styles for other statuses
    //     }
    //     return (
    //         <div className="status-indicator-bar" style={StatusIndicatorBarstyle}>
    //           {status ==="PENDING" && <div className="status-indication-pending-bar"></div>}
    //         </div>
    //     );
    // };

    return (
        <div>
            <div className="darbaord-progress-bar-indicator-container">
                <StatusIndicatorCircle status={isStoreCreated ? isStoreCreated : 'AWAIT'} stepCount="1"/>
                <StatusIndicatorBar status={isBranchAdded ? isBranchAdded : 'AWAIT'}  />
                <StatusIndicatorCircle status={isBranchAdded ? isBranchAdded : 'AWAIT'} stepCount="2"/>
                <StatusIndicatorBar status={isCategoriesCreated ? isCategoriesCreated : 'AWAIT'} />
                <StatusIndicatorCircle status={isCategoriesCreated ? isCategoriesCreated : 'AWAIT'} stepCount="3"/>
                <StatusIndicatorBar status={isProductAdded ? isProductAdded : 'AWAIT'}/>
                <StatusIndicatorCircle status={isProductAdded ? isProductAdded : 'AWAIT'} stepCount="4"/>
                <StatusIndicatorBar status={isDeployed ? isDeployed : 'AWAIT'} />
                <StatusIndicatorCircle status={isDeployed ? isDeployed : 'AWAIT'} stepCount="5"/>
            </div>
            <div className="darbaord-progress-bar-indicator-container">

            </div>
        </div>
    );
};

export default DashboardProgressBar;
